export default __webpack_public_path__ + "static/media/3889.bd9de19b.png";